import * as React from "react";
const SvgMarkunreadMailbox = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 6H10v6H8V4h6V0H6v6H2v16h20V6z",
  fill: "currentColor"
}));
export default SvgMarkunreadMailbox;